__turbopack_context__.v({
  "km": "RetailerLocation-module__t6Op0W__km",
  "root": "RetailerLocation-module__t6Op0W__root",
});
